import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const MeasuringMethodsListSearchParamsSchema = createPaginationSchema().concat(
  createSortSchema(['name', 'acceptedEvidence'])
);
